<script setup lang="ts">
import { onMounted, onBeforeUnmount } from 'vue'
import Lenis from '@studio-freight/lenis'
import HeaderView from '@/components/HeaderView.vue'
import AboutContentView from '@/components/AboutContentView.vue'
import FooterView from '@/components/FooterView.vue'

let lenis: Lenis | null = null

onMounted(() => {
  lenis = new Lenis({
    lerp: 0.1,
    smoothWheel: true,
  })
  function raf(time: number) {
    lenis?.raf(time)
    requestAnimationFrame(raf)
  }
  requestAnimationFrame(raf)

  // Restablecer scroll al inicio de la página
  window.scrollTo({ top: 0, behavior: 'smooth' })
})

onBeforeUnmount(() => {
  if (lenis) {
    lenis.destroy()
  }
})
</script>

<template>
  <div>
    <HeaderView />
    <AboutContentView />
    <FooterView />
  </div>
</template>
